import React from 'react';
import Card from './Card';
import '../css/Home.css';

const Home02 = () => {
    const heading1 = 'OUR';
    const heading2 = 'PROGRAMS';
    const subHeading = 'Take the first step and discover your child’s amazing SMART potential today!';

    return (
        <div className='home02-container flex-center'>
            <div className='flex-center home02-left-pane'>
                <div className='home02-text-container'>
                    <div className='home02-heading1 palanquin-dark bold tertiary-blue-text'>
                        {heading1}
                    </div>
                    <div className='home02-heading2 palanquin-dark bold tertiary-blue-text'>
                        {heading2}
                    </div>
                    <div className='home02-subheading outfit'>
                        {subHeading}
                    </div>
                    <div className='home02-learn-more-container'>
                        <div className='home-learn-more home02-learn-more secondary-white-text flex-center'>
                            Learn More
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex-center home02-right-pane'>
                <div className='home02-images-container flex-center'>
                    <Card title='PRESCHOOL' image='preschool' position='top'/>
                    <Card title='ELEMENTARY' image='elementary' position='top'/>
                    <Card title='JUNIOR HIGH SCHOOL' image='jhs' position='bottom'/>
                    <Card title='SPECIAL EDUCATION' image='sped' position='bottom'/>
                </div>
            </div>
        </div>
    );
};

export default Home02;